// src/components/jobPost/steps/Step5Schedule.jsx
import { useState } from "react";
import { Card, CardContent } from "../../../ui/card";
import { Calendar } from "../../../ui/calendar"; 
import { useJobPostProgressContext } from "../../../../context/jobPostProgressFrom";
import { StepFooterNav } from "../../shared/NavigationFooter";
import { FaClock, FaCalendarCheck } from "react-icons/fa";

export function Step5({ currentStep, totalSteps, nextStep, preStep }) {
  const { jobPostProgress, setScheduledDate } = useJobPostProgressContext();

  const today = new Date();
  const initialDate = jobPostProgress.scheduledDate
    ? new Date(jobPostProgress.scheduledDate)
    : today;

  const [selected, setSelected] = useState(initialDate);
  const [month, setMonth] = useState(initialDate); // controls which month calendar opens to

  const handleDateSelect = (date) => {
    if (date) {
      setSelected(date);
      setScheduledDate(date);
      setMonth(date); // jump to selected date’s month
    }
  };

  const handleNext = () => {
    if (!selected) return;
    setScheduledDate(selected);
    nextStep();
  };

  return (
    <div className="space-y-12 py-5 md:py-10">
      {/* Title */}
      <div className="text-center space-y-4">
  <h1 className="text-3xl md:text-5xl font-bold text-black">Schedule</h1>
  <p className="text-xl text-gray-600 max-w-2xl mx-auto">
    When do you need this service completed?
  </p>
  
  <div className="max-w-xl mx-auto mt-8 space-y-4">
  {/* Same Day Instruction */}
  <div className="flex items-start gap-4 rounded-lg border border-gray-200 bg-gray-50 p-4">
    <div className="w-12 h-12 shrink-0 bg-blue-100 rounded-lg flex items-center justify-center">
      <FaClock className="w-6 h-6 text-blue-600" />
    </div>
    <div className="text-left">
      <h3 className="text-base font-semibold text-gray-900">Same-day</h3>
      <p className="text-sm text-gray-600 mt-1 leading-relaxed">
        Pre-authorization only. Payment when service complete.
      </p>
    </div>
  </div>

  {/* Future Dates Instruction */}
  <div className="flex items-start gap-4 rounded-lg border border-gray-200 bg-gray-50 p-4">
    <div className="w-12 h-12 shrink-0 bg-green-100 rounded-lg flex items-center justify-center">
      <FaCalendarCheck className="w-6 h-6 text-green-600" />
    </div>
    <div className="text-left">
      <h3 className="text-base font-semibold text-gray-900">Future dates</h3>
      <p className="text-sm text-gray-600 mt-1 leading-relaxed">
        Payment required to schedule posting.
      </p>
    </div>
  </div>
</div>
</div>

      {/* Calendar */}
      <div className="max-w-sm mx-auto">
        <Card>
          <CardContent>
            <Calendar
              mode="single"
              selected={selected}
              onSelect={handleDateSelect}
              month={month}
              onMonthChange={setMonth}
              fromMonth={new Date()} // ✅ cannot go before current month
              toMonth={
                new Date(
                  new Date().getFullYear(),
                  new Date().getMonth() + 3,
                  1
                )
              } // ✅ limit to next 3 months
              disabled={(date) =>
                date < new Date(new Date().setHours(0, 0, 0, 0))
              }
              initialFocus
              className="w-full"
            />
          </CardContent>
        </Card>
      </div>

      {/* Footer Navigation */}
      <StepFooterNav
        currentStep={currentStep}
        totalSteps={totalSteps}
        onBack={preStep}
        onNext={handleNext}
      />
    </div>
  );
}
